export default class Classification {
	constructor() {
		this.id = null;
		this.title = null;
	}
}